// extracted by mini-css-extract-plugin
export default {"social-media-links":"kAfbvkc","social-media-links__list":"gRxP2m9","social-media-links__item":"CvL9Ym_"};